import { Component, Input, Inject } from '@angular/core';
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: 'side-effect-determine-well-faorganizationid',
    templateUrl: './side-effect-determine-well-faorganizationid.html',
    standalone: false
})
export class SideEffectDetermineWellFAOrganizationIdComponent {
    _seConfiguration: any;
    isPartofWellTransfer = false;

    set seConfiguration(value: any) {
        this._seConfiguration = value || {};

        this._seConfiguration.organizationId = this._seConfiguration.organizationId || '';
        this._seConfiguration.sellerOrganizationId = this._seConfiguration.sellerOrganizationId || '';
        this._seConfiguration.wellsToTransfer = this._seConfiguration.wellsToTransfer || '';
        this._seConfiguration.targetObjectIsArrayOfWells = this._seConfiguration.targetObjectIsArrayOfWells || false;
        this._seConfiguration.faOrganizationIdContextTarget = this._seConfiguration.faOrganizationIdContextTarget || '';

    }
    get seConfiguration(): any {
        return this._seConfiguration;
    }

    constructor(
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.seConfiguration = data.configuration;

        if (this._seConfiguration.sellerOrganizationId || this._seConfiguration.wellsToTransfer || this._seConfiguration.targetObjectIsArrayOfWells)
            this.isPartofWellTransfer = true;
    }
}
